import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { DashboardWidgetFC } from '@frontend/grid-dashboard';
import { BulkCampaignWidget, bulkCampaignWidgetSize } from './bulk-campaign-widget';

/**
 * @dashboard-widget
 *
 * id: bulk-email-widget
 * title: Bulk Email
 * description: Track your email marketing allotment with a real-time progress bar and remaining message count display.
 * icon: email-small
 */
export const BulkEmailWidget: DashboardWidgetFC = () => {
  return <BulkCampaignWidget campaignType={CampaignType.EMAIL} />;
};

BulkEmailWidget.config = {
  size: bulkCampaignWidgetSize,
  feature: 'email',
};
